import { Gift, Gamepad2, Award, BadgeCheck, Globe2, MapPin, Sparkles, TrendingUp } from "lucide-react";

const ICONS = {
  gift: Gift,
  gamepad: Gamepad2,
  award: Award,
  badge: BadgeCheck,
  globe: Globe2,
  mappin: MapPin,
  sparkles: Sparkles,
  trending: TrendingUp,
};

const VARIANTS = [
  "linear-gradient(135deg, #0816a8 0%, #3b4ed8 100%)",
  "linear-gradient(135deg, #06117e 0%, #0816a8 55%, #2a33c4 100%)",
  "linear-gradient(135deg, #3b4ed8 0%, #7a86ea 100%)",
  "linear-gradient(120deg, #0816a8 0%, #1a2fc0 55%, #f4a900 160%)",
];

export default function ArticleCover({ icon = "gift", tag = "", index = 0, tall = false }) {
  const Icon = ICONS[icon] || Gift;
  const bg = VARIANTS[index % VARIANTS.length];

  return (
    <div
      className={`relative overflow-hidden ${tall ? "aspect-[16/8]" : "aspect-[16/9]"}`}
      style={{ background: bg }}
      aria-hidden="true"
    >
      <div className="absolute -right-8 -bottom-10 opacity-20">
        <Icon className={tall ? "h-44 w-44 text-white" : "h-32 w-32 text-white"} strokeWidth={1} />
      </div>
      <div className="absolute left-0 top-0 h-full w-1.5 bg-[#f4a900]" />
      {tag && (
        <span className="absolute left-4 top-4 rounded-full bg-white/15 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-white backdrop-blur-sm">
          {tag}
        </span>
      )}
    </div>
  );
}
